<template>
  <div>
    <custom-actions show-back :title="title">
      <el-form class="form" v-loading='loading' :model="formData" :rules="rules" ref="form" label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="userId">
              <el-select :disabled="!!inventoryId" filterable v-model="formData.userId" @change="onChangeUser"
                placeholder="请选择客户名称">
                <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品种规格" prop="specId">
              <el-select filterable :disabled="!!inventoryId" @change="onChangeSpec" v-model="formData.specId"
                placeholder="请选择品种规格">
                <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否散油" prop="isBulkOil">
              <el-radio-group v-model="formData.isBulkOil" disabled>
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygId" label="关联仓库">
              <el-select filterable v-model="formData.ygId" placeholder="请选择关联仓库">
                <el-option v-for="(item, index) of warehouseList" :value="item.warehouseId" :label="item.warehouseName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

<!--          <el-col :span="12">-->
<!--            <el-form-item prop="jxRatio" label="绩效系数">-->
<!--              <el-input-number v-model="formData.jxRatio"></el-input-number>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <!-- 现在这个addQuantity字段无用了，到云采处理 -->
          <!-- <el-col :span="12" v-if="recordType == '5'">
            <el-form-item prop="addQuantity" label="出库数量">
              <el-input-number v-model="formData.addQuantity"></el-input-number>
            </el-form-item>
          </el-col> -->
          <el-col :span="12" v-if="recordType !== 'A3'">
            <el-form-item prop="planQuantity" label="计划数量">
              <el-input-number v-model="formData.planQuantity"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col v-if="recordType == 'A3'" :span="12">
            <el-form-item prop="trueQuantity" label="实际数量">
              <el-input-number v-model="formData.trueQuantity"></el-input-number>
            </el-form-item>
          </el-col>

          <!-- 销售入库与调拨单需要填写租金和是否需要缴纳租金 -->
          <template v-if="['B4', 'A3'].includes(recordType)">
            <el-col :span="12">
              <el-form-item prop="isShippingFee" :label="recordType === 'B4' ? '仓储费是否需要缴纳' : '货转费是否需要缴纳'">
                <el-radio-group v-model="formData.isShippingFee">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :prop="formData.isShippingFee === '1' ? 'shippingFee' : ''"
                :label="recordType === 'B4' ? '仓储费单价' : '货转费单价'">
                <el-input v-model="formData.shippingFee"
                  :placeholder="recordType === 'B4' ? '请输入仓储费单价' : '请输入货转费单价'"></el-input>
              </el-form-item>
            </el-col>
          </template>

          <template v-if="recordType == 'A3'">
            <el-col :span="12">
              <el-form-item prop="receiveYgId" label="调拨单接收仓库">
                <el-select clearable filterable v-model="formData.receiveYgId" placeholder="请选择调拨单接收仓库">
                  <el-option v-for="(item, index) of jsWarehouseList" :value="item.warehouseId"
                    :label="item.warehouseName" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="receiveUserName" label="调拨单接收客户">
                <!-- <el-select filterable v-model="formData.receiveUserId" placeholder="请选择调拨单接收客户">
                  <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                    :key="index"></el-option>
                </el-select> -->
                <el-input v-model="formData.receiveUserName" placeholder="请输入调拨单接收客户" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="ygNotes" label="合同编号">
                <el-input type="text" placeholder="请输入合同编号" v-model="formData.ygNotes">
                </el-input>
              </el-form-item>
            </el-col>
          </template>
          <!-- 除了调拨单，其他都要填司机相关信息 -->
          <template v-if="recordType !== 'A3'">
            <!-- <el-col :span="12">
              <el-form-item prop="vehicleKey" label="车牌号">
                <el-select v-model="currentVehicleKey" :filterable="true" :clearable="true" placeholder="输入车牌号/姓名搜索"
                  @change="carChange">
                  <el-option v-for="(item, index) of carList" :value="`${item.vehicleKey}(${item.driverName})`"
                    :label="`${item.vehicleKey}(${item.driverName})`" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="driverName" label="司机姓名">
                <el-input v-model="formData.driverName" :readonly="true" placeholder="请输入司机姓名" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="driverMobile" label="司机手机号">
                <el-input v-model="formData.driverMobile" :readonly="true" placeholder="请输入司机手机号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleGph" label="挂车号">
                <el-input v-model="formData.vehicleGph" :readonly="true" placeholder="请输入挂车号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="driverKey" label="司机身份证">
                <el-input v-model="formData.driverKey" :readonly="true" placeholder="请输入司机身份证" clearable></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item prop="isVehicle" label="是否需要预约">
                <el-radio-group v-model="formData.isVehicle">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col v-if="formData.isVehicle === '2'" :span="12">
              <el-form-item prop="trueQuantity" label="实际数量">
                <el-input-number v-model="formData.trueQuantity"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleDateStart" label="预约开始时间">
                <el-date-picker v-model="formData.vehicleDateStart" placeholder="请选择预约开始时间" type="date" clearable
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleDateEnd" label="预约结束时间">
                <el-date-picker v-model="formData.vehicleDateEnd" placeholder="请选择预约结束时间" type="date" clearable
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item prop="vehicleDate" label="车辆进厂日期">
                <el-date-picker v-model="formData.vehicleDate" placeholder="请选择车辆进厂日期" type="date" clearable
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleTime" label="车辆进厂时间">
                <el-radio-group v-model="formData.vehicleTime">
                  <el-radio :label="item.value" v-for="item of vehicleTimeTypeList" :key="item.value">{{ item.label
                  }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="ygRegion" label="省市区">
                <el-cascader v-model="areaValue" :props="{ value: 'label', label: 'label' }" :options="areaData"
                  @change="handleAreaChange"></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="ygAddress" label="详细地址">
                <el-input v-model="formData.ygAddress" placeholder="请输入详细地址" clearable></el-input>
              </el-form-item>
            </el-col> -->

            <el-col :span="24">
              <el-form-item prop="ygNotes" label="备注">
                <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入备注" v-model="formData.ygNotes">
                </el-input>
              </el-form-item>
            </el-col>

          </template>

          <el-col :span="24" v-if="!(recordType === 'A3' && !inventoryId && !isApproval)">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" :maxSize="50"></file-upload>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row v-if="recordType !== 'A3'">
          <el-col :span="24">
            <el-form-item label="车辆信息" prop="vehicleList">
              <div style="display: flex;align-items: center;margin-bottom: 10px;">
                <el-button size="small" type="primary" @click="addVehicle">新增车辆</el-button>
                <!-- <el-button type="primary" @click="importVehicle" style="margin-bottom: 10px">导入车辆</el-button> -->
                <el-upload v-if="!inventoryId" class="ml10" :on-success="handleSuccess"
                  :headers="{ token: $store.state.token }" :action="$apis.cyCrkManage.selectByXlsData"
                  :show-file-list="false">
                  <el-button size="small" type="primary">导入车辆</el-button>
                </el-upload>
                <el-button v-if="!inventoryId" class="ml10" size="small" type="primary"
                  @click="downloadVehicleTemplate">车辆模板下载</el-button>
              </div>
              <el-table :data="formData.vehicleList" border style="width: 100%">
                <el-table-column prop="vehicleKey" label="车牌号" width="180">
                  <template v-slot="{ row, $index }">
                    <!-- <el-input v-if="scope.row.edit" v-model="scope.row.vehicleKey" placeholder="请输入车牌号"></el-input> -->
                    <el-form-item :prop="`vehicleList.${$index}.currentVehicleKey`"
                      :rules="[{ required: true, message: '请选择' }]">
                      <el-select v-if="row.edit" v-model="row.currentVehicleKey" @change="val => carChange(val, row)"
                        :filterable="true" :clearable="true" placeholder="请选择车牌号">
                        <el-option v-for="(item, index) of carList" :value="`${item.vehicleKey}(${item.driverName})`"
                          :label="`${item.vehicleKey}(${item.driverName})`" :key="index"></el-option>
                      </el-select>
                      <span v-else>{{ row.vehicleKey }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="driverName" label="司机姓名" width="180"></el-table-column>
                <el-table-column prop="driverMobile" label="司机手机号" width="180"></el-table-column>
                <el-table-column prop="vehicleGph" label="挂车号" width="180"></el-table-column>
                <el-table-column prop="driverKey" label="司机身份证" width="220"></el-table-column>
                <el-table-column prop="planQuantity" label="计划数量" width="220">
                  <template v-slot="{ row }">
                    <el-input v-if="row.edit" v-model="row.planQuantity" placeholder="请输入计划数量"></el-input>
                    <span v-else>{{ row.planQuantity }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="addQuantity" label="提货数量" width="220">
                  <template v-slot="{ row }">
                    <el-input v-if="row.edit" v-model="row.addQuantity" placeholder="请输入提货数量"></el-input>
                    <span v-else>{{ row.addQuantity }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="trueQuantity" label="实际入库数量" width="220">
                  <template v-slot="{ row }">
                    <el-input v-if="row.edit & formData.isVehicle === '2'" v-model="row.trueQuantity"
                      placeholder="请输入实际入库数量"></el-input>
                    <span v-else>{{ row.trueQuantity }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="150" fixed="right">
                  <template v-slot="{ row, $index }">
                    <el-button v-if="!row.edit" type="primary" size="small" @click="editVehicle(row)">编辑</el-button>
                    <el-button v-else type="success" size="small" @click="saveVehicle(row)">保存</el-button>
                    <el-button v-if="formData.vehicleList.length > 1" type="danger" size="small"
                      @click="deleteVehicle(row, $index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="isApproval == 1">
          <el-col :span="12">
            <el-form-item prop="nodeResult" label="审批状态">
              <el-radio-group v-model="formData.nodeResult">
                <el-radio label="1">审批通过</el-radio>
                <el-radio label="2">审批驳回</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="nodeOpinion" label="审批意见">
              <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见" v-model="formData.nodeOpinion">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit">{{ recordType === 'A3' && !formData.inventoryId ? '提交并生成货转单' : '提交'
          }}</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
import { validPhoneNumber, validIDCard, validNumber2 } from '@/utils/validator.js'
import { cyRecType, vehicleTimeType } from '@/utils/dict'
import { mapToObjectArray, uniqueByID, deepClone } from '@/utils/utils.js'
// 销售出库：A1
// 调拨单: A3 这个是储运内部从一个仓库调拨到另一个仓库
// 租赁入库：B4
// 租赁出库：A4
export default {
  name: 'CycrkManage',
  data() {
    return {
      cyRecTypeMap: cyRecType,
      carList: [],
      currentVehicleKey: '',
      vehicleTimeTypeList: mapToObjectArray(vehicleTimeType),
      vehicleList: [],
      formData: {
        userId: '',
        specId: '',
        isBulkOil: '', // 1：散油，2：非散油
        recordType: '',
        inoutType: '',
        addQuantity: undefined,
        planQuantity: undefined,
        trueQuantity: undefined,
        // jxRatio: 0,
        ygId: '',
        receiveYgId: '',
        receiveUserId: '',
        receiveUserName: '',
        driverName: '',
        driverMobile: '',
        vehicleKey: '',
        isVehicle: '', // 是否需要预约 1是 2否
        vehicleDateStart: '', // 预约开始时间
        vehicleDateEnd: '', // 预约结束时间
        vehicleGph: '', // 挂车号
        driverKey: '', // 司机身份证
        vehicleType: '1', // 1：车辆，2：船
        vehicleDate: '',
        vehicleTime: '',
        ygRegion: '',
        ygAddress: '',
        shippingFee: '',
        isShippingFee: '2',
        ygNotes: '',
        fileList: [],
        vehicleList: []
      },
      rules: {
        fileList: [{ required: false, message: '请上传附件', trigger: ['change', 'blur'] }],
        userId: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
        specId: [{ required: true, message: '请选择品种规格', trigger: 'change' }],
        recordType: [{ required: false, message: '请选择记录类型', trigger: 'change' }],
        // jxRatio: [{ required: true, message: '请输入绩效系数', trigger: 'blur' }],
        planQuantity: [{ required: true, message: '请输入计划数量', trigger: 'blur' }],
        trueQuantity: [{ required: false, message: '请输入实际数量', trigger: 'blur' }],
        ygId: [{ required: true, message: '请选择关联仓库', trigger: 'change' }],
        receiveYgId: [{ required: true, message: '请选择调拨单接收油罐', trigger: 'change' }],
        receiveUserName: [{ required: true, message: '请输入调拨单接收客户', trigger: 'change' }],
        driverName: [{ required: false, message: '请输入司机姓名', trigger: 'blur' }],
        driverKey: [{ pattern: validIDCard, message: '身份证号格式错误' }],
        isVehicle: [{ required: true, message: '请选择是否需要预约', trigger: 'change' }],
        driverMobile: [
          { required: false, message: '请输入司机手机号', trigger: ['change', 'blur'] },
          { pattern: validPhoneNumber, message: '手机号格式错误' }
        ],
        vehicleKey: [{ required: false, message: '请输入车牌号', trigger: 'blur' }],
        vehicleType: [{ required: false, message: '请选择类型', trigger: 'change' }],
        vehicleDate: [{ required: false, message: '请选择车辆进厂日期', trigger: 'change' }],
        vehicleTime: [{ required: false, message: '请选择车辆进厂时间', trigger: 'change' }],
        ygRegion: [{ required: false, message: '请选择省市区', trigger: 'change' }],
        ygAddress: [{ required: false, message: '请输入地址', trigger: 'blur' }],
        shippingFee: [
          { required: true, message: '请输入单价' },
          { pattern: validNumber2, message: '请输入数字并保留2位小数' }
        ],
        isShippingFee: [{ required: true, message: '请选择运费是否需要缴纳', trigger: 'change' }],
        nodeOpinion: [{ required: true, message: '请输入审批意见', trigger: 'blur' }],
        nodeResult: [{ required: true, message: '请选择审批状态', trigger: 'change' }],
        vehicleList: [{ required: true, type: 'array', message: '请添加车辆' }]
        // ygNotes: '',
        // fileList: []
      },
      resultArr: [
        {
          label: '审批通过',
          value: '1'
        },
        {
          label: '审批驳回',
          value: '2'
        }
      ],
      userList: [],
      specList: [],
      warehouseList: [],
      jsWarehouseList: [],
      loading: false,
      areaValue: [],
      areaData: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    inventoryId() {
      return this.$route.query.inventoryId
    },
    recordType() {
      return this.$route.query.recordType
    },
    isApproval() {
      return this.$route.query.isApproval
    },
    title() {
      const name = this.cyRecTypeMap.get(this.recordType)
      if (this.isApproval) {
        return '审批' + name
      }
      return (this.inventoryId ? '编辑' : '新增') + name
    }
  },
  async created() {
    this.loadUserList()
    this.loadCarList()
    // 非调拨单是要填车辆以及地址信息的
    if (this.recordType !== 'A3') {
      this.loadArea()
    }
    if (this.inventoryId) { // 编辑
      await this.loadDetails()
      this.loadSpecList()
      this.loadWarehouseList()
      if (this.recordType === 'A3') { // 如果是调拨单要同时在加载一遍接收的仓库
        this.loadJsWarehouseList()
      }
    } else { // 新增
      // B4是入库，入库的话需要加载全量规格，出库的话根据客户选择的加载规格
      this.formData.recordType = this.recordType
      if (this.recordType === 'B4') {
        this.loadSpecList()
        this.formData.inoutType = '1' // 入库
      } else {
        this.formData.inoutType = '2' // 出库
      }
    }
  },
  methods: {
    downloadVehicleTemplate() {
      console.log('process.env.BASE_URL', process.env.BASE_URL)
      const link = document.createElement('a')
      link.href = process.env.BASE_URL + 'document/car.xlsx'
      link.download = 'car.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleSuccess(res) {
      console.log('ressssss', res)
      if (res.code === 200) {
        const data = res.data
        console.log('解析exceldatadata', data)
        // 给车辆列表添加edit属性用于编辑
        if (data && data.length > 0) {
          data.forEach(item => {
            item.edit = false
            item.currentVehicleKey = `${item.vehicleKey}(${item.driverName})`
          })
          this.formData.vehicleList = data.filter(item => this.carList.some(item2 => item.currentVehicleKey === item2.currentVehicleKey))
          if (this.formData.vehicleList.length !== data.length) {
            this.$message({
              message: '导入的文件中包含了不在系统中的车辆信息，请检查后重新导入',
              type: 'warning'
            })
          }
        } else {
          this.$message({
            message: '导入的文件中没有车辆信息',
            type: 'warning'
          })
        }
      } else {
        this.$message({
          message: res.message || '导入失败',
          type: 'warning'
        })
      }
    },
    importVehicle() {
    },
    addVehicle() {
      this.formData.vehicleList.push({
        inoutType: this.formData.inoutType,
        currentVehicleKey: '',
        vehicleKey: '',
        driverName: '',
        driverMobile: '',
        vehicleGph: '',
        driverKey: '',
        planQuantity: '', // 计划数量 新增
        addQuantity: '', // 出货数量 新增
        trueQuantity: '', // 真实数量 查看
        vehicleType: '',
        fileList: [],
        edit: true
      })
    },
    editVehicle(row) {
      // if (this.formData.vehicleList.some(item => item.edit)) {
      //   this.$message({
      //     message: '请先保存当前编辑的车辆',
      //     type: 'warning'
      //   })
      //   return
      // }
      row.edit = true
    },
    saveVehicle(row) {
      if (row.inoutVehicleId) {
        const formData = deepClone(row)
        delete formData.edit
        delete formData.currentVehicleKey
        this.$axios.post(this.$apis.cyCrkManage.updateYgnInoutVehicle, formData).then(res => {
          this.loadDetails()
        })
      } else {
        if (this.inventoryId) {
          const formData = deepClone(row)
          delete formData.edit
          delete formData.currentVehicleKey
          this.$axios.post(this.$apis.cyCrkManage.insertYgnInoutVehicle, {
            ...formData,
            inventoryId: this.inventoryId
          }).then(res => {
            this.loadDetails()
          })
        } else {
          row.edit = false
        }
      }
    },
    deleteVehicle(row, index) {
      if (row.inoutVehicleId) {
        this.$axios.post(this.$apis.cyCrkManage.deleteDataYgnInoutVehicle, {
          inoutVehicleId: row.inoutVehicleId
        }).then(res => {
          this.loadDetails()
        })
      } else {
        this.formData.vehicleList.splice(index, 1)
      }
    },
    loadCarList() {
      console.log('typeof', typeof this.formData.isBulkOil)
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByPage, {
        planType: this.formData.isBulkOil === 1 ? '2' : '1'
      }).then(res => {
        this.carList = res.list.map(item => {
          return {
            currentVehicleKey: `${item.vehicleKey}(${item.driverName})`,
            ...item
          }
        })
      })
    },
    carChange(val, row) {
      const carInfo = this.carList.find(item => item.currentVehicleKey === val)
      if (carInfo) {
        row.vehicleKey = carInfo.vehicleKey
        row.driverName = carInfo.driverName
        row.driverMobile = carInfo.driverMobile
        row.driverKey = carInfo.driverKey
        row.vehicleGph = carInfo.vehicleGph
        if (row.planType === '1') {
          row.vehicleType = '1'
        } else { // planType为2
          row.vehicleType = row.isOiltanker === '0' ? '2' : '3'
        }
      } else {
        row.vehicleKey = ''
        row.driverName = ''
        row.driverMobile = ''
        row.driverKey = ''
        row.vehicleGph = ''
        row.vehicleType = ''
      }
    },
    onChangeSpec(specId) {
      this.formData.ygId = '' // 先清空仓库品种规格变化后，入库根据是否散油查仓库，出库根据客户和品种规格查仓库
      const data = this.specList.find(item => item.specId === specId)
      this.formData.isBulkOil = data.isBulkOil
      this.loadCarList()
      this.loadWarehouseList()
      if (this.recordType === 'A3') { // 如果是调拨单要同时在加载一遍接收的仓库
        this.loadJsWarehouseList()
      }
    },
    onChangeUser() {
      // 出库的时候，在客户变化的时候要重新刷新，客户的规格和仓库
      if (this.recordType !== 'B4') {
        this.formData.specId = '' // 客户变化后，要清空品种规格
        this.formData.ygId = '' // 客户变化后，要清空关联仓库
        this.warehouseList = []
        this.loadSpecList()
      }
    },
    loadSpecList() {
      // B4是租赁入库，选择是全量的规格
      if (this.recordType === 'B4') {
        this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList).then(res => {
          this.specList = res.list || []
        })
      } else { // 出库是根据客户选择的规格
        this.$axios.get(this.$apis.prodManage.selectLyWareManByPage, {
          userId: this.formData.userId // 选客户后
        }).then(res => {
          this.specList = uniqueByID(res.list, 'specId')
        })
      }
    },
    loadJsWarehouseList() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage, {
        managerType: this.formData.isBulkOil === 1 ? '1' : '2'
      }).then(res => {
        this.jsWarehouseList = res.list
      })
    },
    loadWarehouseList() {
      // B4是入库，取的是所有仓库，根据规格里面是否散油，存油罐还是非油罐仓库
      if (this.recordType === 'B4') {
        // managerType，1：油罐，2：非油罐
        console.log('this.formData.isBulkOil', this.formData.isBulkOil)
        console.log('this.formData.isBulkOil', typeof this.formData.isBulkOil)
        this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage, {
          managerType: this.formData.isBulkOil === 1 ? '1' : '2'
        }).then(res => {
          this.warehouseList = res.list
        })
      } else { // 出库是看客户有哪些仓库，这个是在产品库存里
        this.$axios.get(this.$apis.prodManage.selectLyWareManByPage, {
          userId: this.formData.userId, // 选客户后
          specId: this.formData.specId // 选规格后
        }).then(res => {
          this.warehouseList = res.list
        })
      }
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2' // 储运客户
      }).then(res => {
        this.userList = res.list || []
      })
    },
    loadArea() {
      this.$axios.get(this.$apis.common.selectCity).then(res => {
        this.areaData = res
      })
    },
    handleAreaChange(value) {
      this.formData.ygRegion = value.join(' ')
    },
    loadDetails() {
      this.loading = true
      return this.$axios.get(this.$apis.cyCrkManage.selectYgnInoutRecordByInventoryId, {
        inventoryId: this.inventoryId
      }).then(res => {
        if (res.ygRegion) {
          this.areaValue = res.ygRegion.split(' ')
        }
        // 给车辆列表添加edit属性用于编辑
        if (res.vehicleList && res.vehicleList.length > 0) {
          res.vehicleList.forEach(item => {
            item.edit = false
            item.currentVehicleKey = `${item.vehicleKey}(${item.driverName})`
          })
        }
        res.addQuantity = res.addQuantity || undefined
        res.planQuantity = res.planQuantity || undefined
        res.trueQuantity = res.trueQuantity || undefined
        res.shippingFee = res.shippingFee || undefined
        res.fileList = res.fileList ? res.fileList : []
        this.formData = res
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.cyCrkManage.insertYgnInoutRecord
        // 如果计划数量和实际数量都有值
        if (this.formData.planQuantity && this.formData.trueQuantity) {
          if (Math.abs(this.formData.planQuantity - this.formData.trueQuantity) > 0.5) {
            this.$confirm('计划数量和实际数量差值超过0.5, 是否确认提交？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if (this.inventoryId) {
                if (this.isApproval === '1') { // 审批
                  url = this.$apis.cyCrkManage.approveYgnInoutRecord
                  if (this.recordType === 'A3') {
                    url = this.$apis.cyCrkManage.approveYgnInoutRecordHz
                  }
                } else {
                  url = this.$apis.cyCrkManage.updateYgnInoutRecord
                }
              }

              const formData = deepClone(this.formData)
              formData.vehicleList.forEach(item => {
                delete item.currentVehicleKey
                delete item.edit
              })

              this.$axios.post(url, formData).then(res => {
                this.$router.back()
              })
            }).catch(() => {
              // 取消提交
            })
          } else {
            if (this.inventoryId) {
              if (this.isApproval === '1') { // 审批
                url = this.$apis.cyCrkManage.approveYgnInoutRecord
              } else {
                url = this.$apis.cyCrkManage.updateYgnInoutRecord
              }
            }
            const formData = deepClone(this.formData)
            formData.vehicleList.forEach(item => {
              delete item.currentVehicleKey
              delete item.edit
            })

            this.$axios.post(url, formData).then(res => {
              this.$router.back()
            })
          }
        } else {
          if (this.inventoryId) {
            if (this.isApproval === '1') { // 审批
              url = this.$apis.cyCrkManage.approveYgnInoutRecord
              if (this.recordType === 'A3') {
                url = this.$apis.cyCrkManage.approveYgnInoutRecordHz
              }
            } else {
              url = this.$apis.cyCrkManage.updateYgnInoutRecord
            }
          }

          const formData = deepClone(this.formData)
          formData.vehicleList.forEach(item => {
            delete item.currentVehicleKey
            delete item.edit
          })
          // 调拨单新增
          if (this.recordType === 'A3' && !this.inventoryId) {
            url = this.$apis.cyCrkManage.insertYgnInoutRecordToPdf
            this.$axios.post(url, formData, {
              responseType: 'blob'
            }).then(res => {
              if (res) {
                const contentDisposition = res.headers['content-disposition']
                let fileName = '货转单.pdf'
                if (contentDisposition) {
                  // 匹配 filename="xxx.pdf"
                  const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
                  if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
                  }
                }
                this.downloadFile(res.data, fileName)

                setTimeout(() => {
                  this.$message({
                    message: '调拨单已生成',
                    type: 'success'
                  })
                  this.$router.back()
                }, 3000)
              }
            })
          } else {
            this.$axios.post(url, formData).then(res => {
              this.$router.back()
            })
          }
        }
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader,
.el-radio-group,
.el-input-number {
  max-width: 400px;
  width: 100%;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}

.el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
